import React, { useCallback } from "react";
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Row, Avatar, Dropdown, Menu, Popover, Button } from "antd";
import WhiteSpace from "components/base/WhiteSpace";
import { noop, get, first } from "lodash";
import { useHistory } from "react-router";
import { IUser, IUserInfo } from "components/CurrentUser/services/typings";
import { useAuthorize, useIsAdmin } from "components/CurrentUser/hooks";
import { Resource, Permission } from "components/CurrentUser/constants";
import { useTranslation } from "react-i18next";
import Box from "components/base/Box";
import styled from "themes/styled";
import { useTheme } from "themes/useTheme";

interface IProps {
  onLogout: () => void;
  user?: IUser | null;
  info?: IUserInfo;
}

const AvatarDropDown = (props: IProps) => {
  const { onLogout = noop, user, info } = props;

  const { push } = useHistory();

  const handleMenuClick = useCallback(
    (params: any) => {
      if (params.key === "logout") {
        onLogout();
      } else if (params.key === "profile") {
        push("/account/profile");
      } else if (params.key === "setting") {
        push("/system-config");
      }
    },
    [onLogout, push]
  );

  const name =
    !!info?.first_name && !!info?.last_name
      ? `${info.first_name} ${info.last_name}`
      : undefined;

  const username = get(user, "username");

  const hasSettingPermission = useAuthorize([
    [Resource.SYSTEM_CONFIGURATION, Permission.VIEW],
    [Resource.SYSTEM_CONFIGURATION, Permission.FULL_VIEW],
  ]);

  const { t } = useTranslation();

  const { themeVariables } = useTheme();

  return (
    <Popover
      placement="bottomLeft"
      content={
        <Box width="200px" p={2}>
          <Box
            display="flex"
            flexDirection="column"
            flex={1}
            justifyContent="center"
            alignItems="center"
            pb={2}
          >
            <Avatar
              style={{ backgroundColor: themeVariables.primary_color }}
              size={56}
            >
              {first(name || username)?.toUpperCase()}
            </Avatar>
            <WhiteSpace />
            <b style={{ fontSize: 14 }}>{name || username}</b>
          </Box>
          <Button type="primary" danger block onClick={onLogout}>
            {t("auth.logout")}
          </Button>
        </Box>
      }
      trigger={["click"]}
    >
      <AvatarContainer>
        <Avatar
          style={{ backgroundColor: themeVariables.primary_color }}
          size={"large"}
        >
          {first(name || username)?.toUpperCase()}
        </Avatar>
      </AvatarContainer>
    </Popover>
  );
};

const AvatarContainer = styled(Box)`
  display: flex;
  height: 60px;
  width: 80px;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${(props) => props.theme.hover_color};
  }
`;

{
  /* <Menu onClick={handleMenuClick}>
          <Menu.Item key={"profile"}>
            <Box display="flex" flexDirection="row" alignItems="center">
              <UserOutlined />
              <WhiteSpace horizontal size="sm" />
              <span>{t("account.my_profile.title")}</span>
            </Box>
          </Menu.Item>
          {hasSettingPermission && (
            <Menu.Item key={"setting"}>
              <Box display="flex" flexDirection="row" alignItems="center">
                <SettingOutlined />
                <WhiteSpace horizontal size="sm" />
                <span>{t("system_configuration.title")}</span>
              </Box>
            </Menu.Item>
          )}
          <Menu.Item key={"logout"}>
            <Box display="flex" flexDirection="row" alignItems="center">
              <LogoutOutlined />
              <WhiteSpace horizontal size="sm" />
              <span>{t("auth.logout")}</span>
            </Box>
          </Menu.Item>
        </Menu> */
}

export default React.memo(AvatarDropDown);
